import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface IncentiveApiParameter extends ApiParameter {
    IncentiveForm: Partial<IncentiveFormModel>;
}

export interface IncentiveFormModel {
    ContractorBusinessName: string;
    DateOfSale: string;
    CrescentInvoiceNumber: string;
    UnitSold : string;
    TypeOfEquipemnt : string;
    ModelNumber: string;
    ThermostatModelNumber: string;
    Manufacturer: string;
    CentralACSize: string;
    CertificationNumber: string;
    BusinessName: string;
    LocationAddress: string;
    Name:string;
    PhoneNumber:string;
    Email:string;
    AccountNumber:string;
}

const customUrl = "/api/incentives/sendemail";

export async function incentiveService(parameter: IncentiveApiParameter): Promise<ServiceResult<IncentiveFormModel>> {
    try {
        const result = await post<IncentiveFormModel>(`${customUrl}`, parameter.IncentiveForm as IncentiveFormModel);
        return {
            result,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}